import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu"
import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { ElementRenderer } from "./element-renderer"
import { cn } from "../lib/utils"

export function DropdownMenuRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent, mode } = useRenderContext()

  const trigger = element.children?.[0]
  const items = element.children?.slice(1) ?? []

  const handleItemClick = (item: typeof items[number]) => {
    const text = item.text ? String(resolveSymbol(item.text) ?? "") : ""
    dispatchEvent(element.id, "select", { value: text })
  }

  return (
    <DropdownMenuPrimitive.Root>
      <DropdownMenuPrimitive.Trigger asChild>
        <div className={cn("cursor-pointer", element.className)} data-testid={`dropdown-menu-${element.id}`}>
          {trigger && <ElementRenderer element={trigger} />}
        </div>
      </DropdownMenuPrimitive.Trigger>
      <DropdownMenuPrimitive.Portal>
        <DropdownMenuPrimitive.Content
          className="z-50 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
          sideOffset={4}
        >
          {items.map((item) => {
            const label = item.text ? String(resolveSymbol(item.text) ?? "") : ""
            return (
              <DropdownMenuPrimitive.Item
                key={item.id}
                className="relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50"
                onSelect={() => handleItemClick(item)}
              >
                {label}
              </DropdownMenuPrimitive.Item>
            )
          })}
        </DropdownMenuPrimitive.Content>
      </DropdownMenuPrimitive.Portal>
    </DropdownMenuPrimitive.Root>
  )
}
